<template>
  <button
    :id="id"
    type="button"
    :data-cy="dataCy"
    :disabled="disabled"
    :class="{
      'tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-px-[8px] tw-py-[2px] tw-bg-[#387DFF] hover:tw-bg-[#211F58] tw-cursor-pointer tw-rounded-[50%] plus-container tw-z-[1]': true,
      '!tw-cursor-not-allowed !tw-bg-[#b7b7b7]': disabled,
    }"
  >
    <img class="tw-h-[10px] tw-w-[10px]" :src="src" alt="icon" />
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {},
})
export default class IconButton extends Vue {
  @Prop({ required: true }) public src!: string;
  @Prop({ required: false }) public disabled!: boolean;
  @Prop({ required: false, default: "" }) public id!: string;
  @Prop({ required: false, default: "" }) public dataCy!: string;
}
</script>
